import React from 'react';
import { ToastContainer as ToastContainerRT } from 'react-toastify';
var ToastContainer = function (_a) {
    return (React.createElement(ToastContainerRT, { position: "bottom-right", autoClose: 5000, hideProgressBar: false, newestOnTop: false, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true }));
};
export { ToastContainer };
//# sourceMappingURL=ToastContainer.js.map